export const STAGE = process.env.STAGE || 'prod'

export const API_URL = 'https://account-recovery-api.demo.signicat.global'
